import PageLayout from "@/components/layout/PageLayout";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import DailyClosingTab from "./DailyClosingTab";
import RevenueSummaryTab from "./RevenueSummaryTab";
import AccountsReceivableTab from "./AccountsReceivableTab";
import VatReportTab from "./VatReportTab";

export default function ReportsPage() {
  return (
    <PageLayout title="Reports" subtitle="Financial reports and analytics">
      <Tabs defaultValue="daily-closing">
        <TabsList className="inline-flex gap-1 rounded-lg border border-border-secondary bg-bg-secondary p-1 mb-6">
          <TabsTrigger
            value="daily-closing"
            className="rounded-md px-4 py-2 text-sm font-medium text-text-secondary data-[state=active]:bg-bg-primary data-[state=active]:text-text-primary data-[state=active]:shadow-sm"
          >
            Daily Closing
          </TabsTrigger>
          <TabsTrigger
            value="revenue"
            className="rounded-md px-4 py-2 text-sm font-medium text-text-secondary data-[state=active]:bg-bg-primary data-[state=active]:text-text-primary data-[state=active]:shadow-sm"
          >
            Revenue
          </TabsTrigger>
          <TabsTrigger
            value="receivables"
            className="rounded-md px-4 py-2 text-sm font-medium text-text-secondary data-[state=active]:bg-bg-primary data-[state=active]:text-text-primary data-[state=active]:shadow-sm"
          >
            Receivables
          </TabsTrigger>
          <TabsTrigger
            value="vat"
            className="rounded-md px-4 py-2 text-sm font-medium text-text-secondary data-[state=active]:bg-bg-primary data-[state=active]:text-text-primary data-[state=active]:shadow-sm"
          >
            VAT
          </TabsTrigger>
        </TabsList>

        <TabsContent value="daily-closing">
          <DailyClosingTab />
        </TabsContent>
        <TabsContent value="revenue">
          <RevenueSummaryTab />
        </TabsContent>
        <TabsContent value="receivables">
          <AccountsReceivableTab />
        </TabsContent>
        <TabsContent value="vat">
          <VatReportTab />
        </TabsContent>
      </Tabs>
    </PageLayout>
  );
}
